export default [
  {
    id: 1,
    label: 'dashboard',
    icon: 'bx-home-alt',
    link: '/',
  },
];
